import type { AppMeta } from "@calcom/types/App";

export const metadata = {
  linkType: "dynamic",
  name: "Zoom Video",
  description:
    "Zoom is a secure and reliable video platform that supports all of your online communication needs. It can provide everything from one on one meetings, chat, phone, webinars, and large-scale online events. Available with both desktop, web, and mobile versions.",
  type: "zoom_video",
  categories: ["conferencing"],
  variant: "conferencing",
  logo: "icon.svg",
  publisher: "Cal.diy",
  url: "https://zoom.us/",
  category: "conferencing",
  slug: "zoom",
  title: "Zoom Video",
  email: "support@hellomatik.com",
  // LIXIL audit (2026-05-15): Zoom is the audited video provider for lixil-meet.
  // In practice it's the only conferencing option exposed — Daily.co is gated
  // behind LIXIL_MEET_ENABLE_DAILY=false in ../dailyvideo/_metadata.ts. The AppMeta
  // type only allows `default: false` for app-level locations (the system
  // default is set elsewhere), so we don't flip the flag here.
  appData: {
    location: {
      default: false,
      linkType: "dynamic",
      type: "integrations:zoom",
      label: "Zoom Video",
    },
  },
  dirName: "zoomvideo",
  isOAuth: true,
} as AppMeta;

export default metadata;
